import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import {
  MARKDOWN_PREVIEW_CODE_BG,
  MARKDOWN_PREVIEW_FONT_FAMILY,
  previewPrismStyle,
} from "./prismPreviewStyle";
import { normalizePrismLanguage } from "./prismLanguages";

const LANGUAGE_CLASS = /language-([\w#.+-]+)/i;

function codeBlockLangLabel(rawFromFence, normalized) {
  const raw = rawFromFence.trim();
  if (raw) return raw;
  const n = normalized.trim();
  if (n && n !== "plaintext" && n !== "text") return n;
  return "code";
}

export const markdownComponents = {
  pre({ children }) {
    return <>{children}</>;
  },

  code({ className, children, node: _node, ...rest }) {
    const match = LANGUAGE_CLASS.exec(className || "");
    const text = String(children).replace(/\n$/, "");
    const hasFenceLang = Boolean(match);
    const looksLikeBlock = hasFenceLang || text.includes("\n");

    if (!looksLikeBlock) {
      return (
        <code className={className} {...rest}>
          {children}
        </code>
      );
    }

    const rawLang = match?.[1] ?? "";

    if (!hasFenceLang) {
      return (
        <div
          className="markdown-fenced-plain"
          role="region"
          aria-label="Code block"
          dir="ltr"
        >
          <pre className="markdown-fenced-plain__pre">
            <code className="markdown-fenced-plain__code">{text}</code>
          </pre>
        </div>
      );
    }

    const language = normalizePrismLanguage(rawLang || "plaintext");
    const langLabel = codeBlockLangLabel(rawLang, language);

    return (
      <figure
        className="markdown-syntax-highlighter-wrap"
        dir="ltr"
        data-language={language}
        aria-label={`Code sample${langLabel ? `, ${langLabel}` : ""}`}
      >
        <figcaption className="markdown-syntax-highlighter__head">
          <span className="markdown-syntax-highlighter__traffic" aria-hidden="true">
            <span className="markdown-syntax-highlighter__traffic-dot" />
            <span className="markdown-syntax-highlighter__traffic-dot" />
            <span className="markdown-syntax-highlighter__traffic-dot" />
          </span>
          <span className="markdown-syntax-highlighter__lang">{langLabel}</span>
        </figcaption>
        <SyntaxHighlighter
          language={language === "plaintext" ? "text" : language}
          style={previewPrismStyle}
          PreTag="div"
          className="markdown-syntax-highlighter"
          codeTagProps={{
            className: "markdown-syntax-highlighter__code",
            style: { fontFamily: MARKDOWN_PREVIEW_FONT_FAMILY },
          }}
          customStyle={{
            margin: 0,
            padding: "16px 18px 18px",
            borderRadius: 0,
            fontSize: "13px",
            lineHeight: 1.65,
            letterSpacing: "0.01em",
            border: "none",
            background: MARKDOWN_PREVIEW_CODE_BG,
            fontFamily: MARKDOWN_PREVIEW_FONT_FAMILY,
            boxShadow: "none",
          }}
          showLineNumbers={false}
          wrapLines={false}
        >
          {text}
        </SyntaxHighlighter>
      </figure>
    );
  },
};
